<ng-container *transloco="let t; prefix: 'PremiseHazard'">
  <form [formGroup]="attachmentForm">
    <div class="field">
      <label class="msi-label">{{ t('View.modal.uploadAttachment.attachmentName') }}</label>
      <input pInputText formControlName="name" />
    </div>
    <div class="field">
      <label class="msi-label">{{ t('View.modal.uploadAttachment.attachmentDescription') }}</label>
      <textarea pTextarea formControlName="description"></textarea>
    </div>
    <div class="field">
      <label class="msi-label">{{ t('View.modal.uploadAttachment.fileLabel') }}</label>
      <input type="file" (change)="onFileChanged($event)" />
      @if (attachmentForm.controls['filePath'].hasError('maxSize')) {
        <div>
          <msi-icon name="ic_error" class="error_icon" />{{ t('View.modal.uploadAttachment.fileSizeLimit') }}
        </div>
      }
    </div>
    <div class="form-row-bottom">
      <button type="button" pButton [outlined]="true"
        (click)="cancel()">
        <msi-icon name="ic_remove" class="delete-icon" />{{ 'Buttons.cancel' | transloco }}
      </button>
      <button type="button" pButton
        (click)="submit()" [disabled]="!attachmentForm.valid">
        <msi-icon name="ic_upload" />{{ t('View.modal.uploadAttachment.upload') }}
      </button>
    </div>
  </form>
</ng-container>
